<template>
  <div class="list row">
    <div class="col-md-12 mr-4">
      <div class="input-group mb-3">
        <input type="date" v-validate="'required|min:10|max:10'" class="form-control mr-2" placeholder="Select start date" v-model="startDate"/>
        <input type="date" v-validate="'required|min:10|max:10'" class="form-control mr-2" placeholder="Select end date" v-model="endDate"/>
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="page = 1; retrieveAuditLogs();"><font-awesome-icon icon="search" /> Search</button>
        </div>
      </div>
    </div>
    <div class="col-md-12 hgap"></div>
    <div class="col-md-8">
      <h4><font-awesome-icon icon="list-alt" /> Audit Logs List</h4>
      <table class="gridview">
        <tr>
            <th>S/N</th><th>initiator Name</th><th>Activity</th><th>Subject</th><th>Date</th><th>Time</th>
        </tr>
        <tr class="" :class="{ active: index == currentIndex }" v-for="(auditLog, index) in auditLogs" :key="index" @click="setActiveAuditLog(auditLog, index)">
            <td>{{ index+1 }}</td><td>{{ auditLog.initiatorName }}</td><td>{{ auditLog.activity }}</td>
            <td>{{ auditLog.subject }}</td><td>{{ auditLog.transactionDate | moment("DD/MM/YYYY") }}</td><td>{{ auditLog.transactionTime | moment("HH:mm:ss") }}</td>
        </tr>
      </table>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-md-4">
      <div v-if="currentAuditLog">
        <h4><font-awesome-icon icon="info-circle" /> Audit Log Details</h4>
        <table class="table">
        <tr>
          <td><strong>Initiator Name:</strong></td><td> {{ currentAuditLog.initiatorName }}</td>
        </tr>
        <tr>
          <td><strong>Activity:</strong></td><td> {{ currentAuditLog.activity }}</td>
        </tr>
        <tr>
          <td><strong>Subject:</strong></td><td> {{ currentAuditLog.subject }}</td>
        </tr>
        <tr>
          <td><strong>Date:</strong></td><td> {{ currentAuditLog.transactionDate | moment("DD/MM/YYYY") }}</td>
        </tr>
        <tr>
          <td><strong>Time:</strong></td><td> {{ currentAuditLog.transactionTime | moment("HH:mm:ss") }}</td>
        </tr>
        </table>

        <!-- <a class="m-3 btn btn-sm btn-warning" :href="'/auditlogs/' + currentAuditLog.id"><font-awesome-icon icon="edit" /> Delete </a>-->
        <!-- <router-link :to="{ path: '/auditlogs/' + currentAuditLog.id }" class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="edit" /> Delete </router-link>-->
      </div>
      <div v-else>
        <br />
        <p>Please click on a Audit Log...</p>
      </div>
    </div>
  </div>
</template>

<script>
import AuditLogService from "../services/audit-log.service";

export default {
  name: "audit-logs-list",
  data() {
    return {
      auditLogs: [],
      currentAuditLog: null,
      currentIndex: 0,
      initiatorName: "",
      startDate: null,
      endDate: null,
      page: 1,
      count: 0,
      pageSize: 100,
      pageSizes: [10, 15, 20, 25, 50, 100],
      totalPages: 0,
      loading: false
    };
  },
  methods: {
    retrieveAuditLogs() {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      if (this.startDate && this.endDate) {
        AuditLogService.getAuditLogsByDate(new Date(this.startDate), new Date(this.endDate), this.page, this.pageSize)
          .then(response => {
            const { auditLogs, totalItems } = response.data;
            this.auditLogs = auditLogs;
            this.count = totalItems;
            this.loading = false;
            //console.log(response.data);
          })
          .catch(e => {
            console.log(e);
          });
      }
      else{        
        AuditLogService.getAll(this.initiatorName, this.page, this.pageSize)
          .then(response => {
            const { auditLogs, totalItems } = response.data;
            this.auditLogs = auditLogs;
            this.count = totalItems;
            this.loading = false;
            //console.log(response.data);
          })
          .catch(e => {
            console.log(e);
          });
      }
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveAuditLogs();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveAuditLogs();
    },

    refreshList() {
      this.retrieveAuditLogs();
      this.currentAuditLog = null;
      this.currentIndex = -1;
    },

    setActiveAuditLog(auditLog, index) {
      this.currentAuditLog = auditLog;
      this.currentIndex = index;
    },

    removeAllAuditLogs() {
      AuditLogService.deleteAll()
        .then(response => {
          console.log(response.data);
          this.refreshList();
        })
        .catch(e => {
          console.log(e);
        });
    },

  },
  mounted() {
    this.retrieveAuditLogs();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}

.gridview
{
    border-collapse: collapse;
    margin: 0px 10px 10px 0;
    /*box-shadow: 3px 3px 4px #bbb;*/
    width: 100%;
    max-width: 100%;    
}

.gridview, .gridview td,  .gridview th
{
    border:  1px solid #cccccc;
}

.gridview th
{
    text-align: left;
    /*font-size: 1.2em;*/
    font-weight: normal;
    color: #F9F9F9;    
    background: #232324;
}

.gridview th a, .gridview th a:link, .gridview th a:visited, .gridview th a:active
{
    color: #fff;
    text-decoration: none;
}

.gridview th a:hover
{
    text-decoration: underline;
}

.gridview tr
{
    background: #fff;
}

.gridview tr:nth-child(odd) 
{
    background-color: #fff;
}
.gridview tr:nth-child(even) 
{
    background-color: #fff;
}

.gridview td 
{
    font-weight: normal;    
    text-align: left;
    vertical-align: top;
}

.gridview td, table th
{
    padding: 5px 8px;
}

.gridview tfoot td
{
    background-color: #fff;
}

.gridview tfoot td .page
{
    color: #000000;
    font-weight: bold;
}

.gridview tr.subfoot, .gridview tr.subfoot td
{
    background-color: #1E90FF;
}

.gridview tr:hover td, .gridview tbody tr:hover td
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview .selected, .gridview tr td .selected
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview tr.active td, .gridview tbody tr.active td
{
    background-color: #1E90FF;
    color: #fff;
}
</style>